import React from 'react';
interface StepFrameProps {
  eyebrow?: string;
  title: string;
  description?: string;
  children: React.ReactNode;
  help?: React.ReactNode;
}
export function StepFrame({
  title,
  description,
  children,
  help
}: StepFrameProps) {
  return <div data-id="element-56" data-mp="1kpuuh2cstqfb">
      <h1 className="text-[28px] font-semibold leading-[1.15] tracking-[-0.025em] text-ink-900 md:text-[34px]" data-id="element-57" data-mp="1kojpiz7macmm">{title}</h1>
      {description && <p className="mt-3 text-base leading-relaxed text-ink-500 md:text-[17px]" data-id="element-58" data-mp="s1gwunpmgw4a">{description}</p>}
      <div className="mt-8" data-id="element-59" data-mp="o0wxrelhnifi">{children}</div>
      {help && <div className="mt-6 space-y-2" data-id="element-60" data-mp="o27zl8vdig3z">{help}</div>}
    </div>;
}
export function FieldGrid({
  children
}: {
  children: React.ReactNode;
}) {
  return <div className="grid gap-4 sm:grid-cols-2" data-id="element-61" data-mp="x0jon6gld5ub">{children}</div>;
}
export function Callout({
  tone = 'info',
  children
}: {
  tone?: 'info' | 'warning';
  children: React.ReactNode;
}) {
  return <div className={`rounded-2xl px-4 py-3.5 text-sm leading-relaxed ${tone === 'warning' ? 'bg-caution-50 text-caution-700' : 'bg-pulse-50 text-pulse-800'}`} role={tone === 'warning' ? 'status' : undefined} data-id="element-62" data-mp="4cnt452rdjz4">
      {children}
    </div>;
}